import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  ToggleStickyFooterVisible = 'page/toggleStickyFooterVisible',
  SetValuationFiltersModalOpened = 'page/setValuationFiltersModalOpened',
  SetPushSettingsOpened = 'page/setPushSettingsOpened',
  SetPushNotificationsAllowed = 'page/setPushNotificationsAllowed',
  ToggleStickyScrollBtnVisible = 'page/toggleStickyScrollBtnVisible',
}

export const toggleStickyFooterVisible = actionGenerator<EActionTypes.ToggleStickyFooterVisible, boolean>(
  EActionTypes.ToggleStickyFooterVisible,
);

export const toggleStickyScrollBtn = actionGenerator<EActionTypes.ToggleStickyScrollBtnVisible, boolean>(
  EActionTypes.ToggleStickyScrollBtnVisible,
);

export const setValuationFiltersModalOpened = actionGenerator<EActionTypes.SetValuationFiltersModalOpened, boolean>(
  EActionTypes.SetValuationFiltersModalOpened,
);

export const setPushSettingsModalOpened = actionGenerator<EActionTypes.SetPushSettingsOpened, boolean>(
  EActionTypes.SetPushSettingsOpened,
);

export const setPushNotificationsAllowed = actionGenerator<EActionTypes.SetPushNotificationsAllowed, boolean>(
  EActionTypes.SetPushNotificationsAllowed,
);

export type TPageActions =
  | ReturnType<typeof toggleStickyFooterVisible>
  | ReturnType<typeof toggleStickyScrollBtn>
  | ReturnType<typeof setValuationFiltersModalOpened>
  | ReturnType<typeof setPushSettingsModalOpened>
  | ReturnType<typeof setPushNotificationsAllowed>;
